  /*
  * 格式化数字
  * number：要格式化的数字
  * decimals：保留几位小数
  * dec_point：小数点符号
  * thousands_sep：千分位符号
  * */
export function formatNumber(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+-Ee.]/g, '');
  let n = !isFinite(+number) ? 0 : +number,
      prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
      sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
      dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
      s = '';

  const toFixedFix = function (n, prec) {
      const k = Math.pow(10, prec);
      return '' + Math.floor(n * k) / k;
  };

  s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
  const re = /(-?\d+)(\d{3})/;

  while (re.test(s[0])) {
      s[0] = s[0].replace(re, "$1" + sep + "$2");
  }

  if ((s[1] || '').length < prec) {
      s[1] = s[1] || '';
      s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

function isPromise(obj) {
  return 'function' == typeof obj.then;
}

// 保证fn返回resolve状态
function toResolvedPromise(fn) {
  return new Promise((resolve, reject) => {
    let result = fn();

    // 非promise结果直接返回
    if (!isPromise(result)) {
      console.log('not promise');
      return resolve(result)
    }

    result.then((data) => {
      resolve(data)
    }).catch((err) => {
      console.log('error:', err);
      resolve(null);
    })
  })
}

// 顺序执行promise
export function runPromiseInSequence(promiseArr) {
  const arr = [];
  async function run() {
    for(let p of promiseArr) {
      const val = await toResolvedPromise(p);
      arr.push(val);
    }
    return arr;
  }
  return run();
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function isString(str) {
  if (typeof str === 'string' || str instanceof String) {
    return true
  }
  return false
}

/**
 * @param {Array} arg
 * @returns {Boolean}
 */
export function isArray(arg) {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export function isBlob(data) {
  return Object.prototype.toString.call(data) === '[object Blob]';
}

export function downloadExcel(fileData, fileName) {
  const url = window.URL.createObjectURL(new Blob([fileData], {type: "application/vnd.ms-excel"}))
  const link = document.createElement('a')
  link.style.display = 'none'
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  setTimeout(() => {
    URL.revokeObjectURL(url); 
  });
}

export function downloadFile(response) {
  // 提取文件名
  const fileName = response.headers['content-disposition'].match(
    /filename=(.*)/
  )[1];

  // 将二进制流转为blob
  const blob = new Blob([response.data], { type: 'application/octet-stream' })
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURIComponent(fileName))
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob)
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', decodeURIComponent(fileName))
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }
    // 挂载a标签
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL)
  }
}

// 防抖
export function debounce(func, ms = 1000) {
  let timer;
  return function(...args) {
    const context = this;
    clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(context, args);
    }, ms);
  }
}

// 节流
export function throttle(func, ms = 1000) {
  let timer;
  return function(...args) {
    if (timer) {
      return;
    }
    const context = this;
    timer = setTimeout(() => {
      func.apply(context, args);
      timer = null;
    }, ms);  
  }
}

// 将target对应属性用source的对应属性填充
export function assignValue(target = {}, source = {}, defaultVal) {
  Object.keys(target)
    .forEach(key => {
      if (source.hasOwnProperty(key)) {
        target[key] = source[key] || defaultVal;
      }
    });
  return target;
}